import { toastSuccess } from "../../toasts";
import { FrameComponent } from "../frames/frame-component";
import { AttributesComponent } from "./attributes-component";

export class AttributesComponentInplace extends AttributesComponent {
    static webComponentName: string = "attributes-input-inplace";
    protected _step: string = 'attributes-form'; // Start directly with the form
    get frameController(): FrameComponent | null {
        return window.frameController || null;
    }
    private frameClose(): void {
        if (this.frameController) {
            this.frameController.close();
        }
    }
    protected afterSave(): void {
        toastSuccess("Parametro salvato con successo.");
        if(!this.frameController) return ;
        this.frameController.actionExecuted = true;
        setTimeout(() => {
            this.frameClose();
        }, 200);
    }
    constructor() {
        super();

    }
    protected buildRenderingData(): Record<string, any> {
        const data = super.buildRenderingData();
        console.log("current", this.current);
        console.log("value", this.value);
        return data;
    }
    protected renderProcessView(): void {
        const attribute = this.current;
        console.log("AttributesComponentInline renderProcess", attribute);
        if (attribute) {
            this.renderForm("edit");
        }
    }
    protected render(): void {
        console.log("AttributesComponentInline render");
        super.render();
    }
}